module.exports = __webpack_public_path__ + "static/media/vine.3274d601.svg";